import axios from "axios";
import Swal from "sweetalert2";

const baseURL = process.env.VUE_APP_BASE_URL;
const apiKey = process.env.VUE_APP_API_KEY;

axios.interceptors.request.use((config) => {
  config.baseURL = baseURL;

  // config.headers.Authorization = `Basic ${account}`;
  config.headers["x-api-key"] = apiKey;
  config.headers.versi = process.env.VUE_APP_VERSI;

  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const data = error.response?.data || {};
    const requestUrl = error.config?.url || "";
    const isLoginRequest = requestUrl.includes("/auth/login");

    if (!status) {
      if (!isLoginRequest) {
        Swal.fire({
          icon: "error",
          title: "Koneksi Gagal",
          text: "Tidak dapat terhubung ke server. Periksa koneksi Anda.",
        });
      }
      return Promise.reject(error);
    }

    if (status == 423 || status == 401) {
      if (isLoginRequest && status == 423) {
        return Promise.reject(error);
      }

      Swal.fire({
        title: "Info",
        text: "Session Habis, Silahkan Login Kembali",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
      });
      setTimeout(() => {
        Swal.close();
        localStorage.removeItem("userData");
        window.location.reload();
      }, 3000);
    }

    if (status == 426) {
      Swal.fire({
        title: "Info",
        text: "Versi Baru Tersedia, Refresh Halaman",
        icon: "info",
        showCancelButton: false,
        showConfirmButton: false,
      });
      setTimeout(() => {
        Swal.close();
        caches
          .keys()
          .then(function (names) {
            for (let name of names) {
              caches.delete(name);
            }
          })
          .then(() => {
            window.location.reload();
          });
      }, 3000);
    }

    if (status == 429) {
      if (!isLoginRequest) {
        Swal.fire({
          icon: "error",
          title: "",
          text: data.message,
        });
      }
    }

    if (status >= 500) {
      if (!isLoginRequest) {
        Swal.fire({
          icon: "error",
          title: "",
          text: data.message || "Terjadi kesalahan pada server.",
        });
      }
    }

    return Promise.reject(error);
  },
);
